import React from "react";
import { Box, IconButton, Stack } from "@mui/material";
import TermText from "../TermsOfUse/components/TermText";
import { isMobile } from "react-device-detect";
import SignInLogo from "../../assets/fluxmed-signin.svg";
import { CircularLoading } from "../../components/common";
import { endpoints } from "../../configs/Settings";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

export function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <Stack width="100%" direction="row">
      {isMobile ? (
        <Stack width="100%" padding="60px 20px">
          <IconButton 
            sx={{ 
              position: "absolute", 
              top: 20, 
              left: 20,
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.9)" }
            }}
            onClick={() => navigate("/signin")}
          >
            <ArrowBackIcon />
          </IconButton>
          <TermText termOf="privacy-policy" />
        </Stack>
      ) : (
        <Stack direction="row" alignItems="center" height="100vh" flex={1}>
          <Box
            component="img"
            src={SignInLogo}
            alt={`Logo ${endpoints.AppName}`}
            sx={{ width: "40%", objectFit: "cover", height: "100vh" }}
            display={{ xs: "none", lg: "flex" }}
          />
          <Stack
            flex={1}
            sx={{
              maxHeight: "100vh",
              overflowY: "auto",
              padding: "20px",
              position: "relative"
            }}
          >
            <IconButton 
              sx={{ 
                position: "absolute", 
                top: 20, 
                left: 20,
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.9)" },
                zIndex: 10
              }}
              onClick={() => navigate("/signin")}
            >
              <ArrowBackIcon />
            </IconButton>
            <TermText termOf="privacy-policy" />
          </Stack>
        </Stack>
      )}
    </Stack>
  );
}

